(function ($) {
    'use strict';

    function openAccordionOrTabByHash () {
        var hashInURL = document.location.href.toString().split('#')[1];

        if (hashInURL) {
            var el = document.getElementById(hashInURL);

            if (el && el.classList.contains('collapse')) {
                $('#' + hashInURL).collapse('show');
            }
        }
    }

    function collapsibleCard () {
        var $card,
            $body = $('html, body'),
            cardPosition,
            bodyPosition;

        /*
        *   function anchorInURL() adds anchor to URL for collapsible panels
        *
        *   parameters:
        *       className: hide/show class
        *       name: id base name
        *       target: collapse or tab
        */
        function anchorInURL (className, name, target) {
            var activeEl, cur;

            if ($(className).length > 0) {
                activeEl = document.location.href.toString().split('#');
                cur = (activeEl.length > 1) ? '#' + activeEl.pop() : '';

                $(className).on('hide.bs.' + target, function () {
                    window.history.pushState(null, name, document.location.href.toString().split('#')[0]);
                });

                $(className).on('shown.bs.' + target, function () {
                    var hashtag;

                    switch (target) {
                        case 'collapse':
                            hashtag = '#' + $(this).attr('id');
                            break;
                        case 'tab':
                            hashtag = $(this).attr('href');
                            break;
                    }

                    window.history.pushState(null, name, hashtag);
                    cur = hashtag;
                });
            }
        }


        anchorInURL('.collapsible-card .collapse', '^accordion-', 'collapse'); // accordions

        $('.collapsible-card .collapse').on('hide.bs.collapse', function () {

            $card = $(this).closest('.collapsible-card');
            cardPosition = $card.offset().top;
            bodyPosition = $body.scrollTop();

            $card.removeClass('active');
            if ($card !== 'undefined') {
                if (cardPosition < bodyPosition) {
                    $body.animate({ scrollTop: cardPosition }, 200);
                }
            }
        });


        $('.collapsible-card .collapse').on('show.bs.collapse', function () {

            $card = $(this).closest('.collapsible-card').removeClass('active');
            $card.addClass('active');
        });

    };

    window.collapsibleCard = collapsibleCard;
    openAccordionOrTabByHash();
    window.addEventListener(
        "hashchange",
        () => {
            openAccordionOrTabByHash();
        },
        false,
    );
}(jQuery));
